<template>
    <div class="position-box">
      <div class="head">
          <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
          <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
          <span class="title">{{$t('langNew2.qd')}}</span>
          <span class="rule" @click="rule">{{$t('langNew2.hdgz')}}</span>
      </div>
      <div class="cotainer sign" @scroll="listenScroll">
        <div class="sign-wrap">
          <ul class="sign-box" v-if="lang == 'ar'">
            <!-- <li class="li">{{$t('langNew2.lq')}}</li> -->
            <li class="li">{{$t('langNew2.yhd')}} <span class="money">{{total_bonus | toFixed4}}USDT</span></li>
          </ul>
          <ul class="sign-box" v-else>
            <li class="li">{{$t('langNew2.yhd')}} <span class="money">{{total_bonus | toFixed4}}USDT</span></li>
            <!-- <li class="li">{{$t('langNew2.lq')}}</li> -->
          </ul>
          <ul class="sign-box2">
            <li class="sign-days" :class="{active: continue_cnt >= 1}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 1" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.dyt')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.dyt')}}</div>
                <img class="icon" v-show="continue_cnt >= 1" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 1" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[0]">{{signList[0].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
            <li class="sign-days" :class="{active: continue_cnt >= 2}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 2" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.det')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.det')}}</div>
                <img class="icon" v-show="continue_cnt >= 2" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 2" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[1]">{{signList[1].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
            <li class="sign-days" :class="{active: continue_cnt >= 3}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 3" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.dst')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.dst')}}</div>
                <img class="icon" v-show="continue_cnt >= 3" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 3" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[2]">{{signList[2].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
          </ul>
            <ul class="sign-box2">
            <li class="sign-days" :class="{active: continue_cnt >= 4}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 4" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.dsit')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.dsit')}}</div>
                <img class="icon" v-show="continue_cnt >= 4" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 4" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[3]">{{signList[3].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
            <li class="sign-days" :class="{active: continue_cnt >= 5}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 5" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.dwt')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.dwt')}}</div>
                <img class="icon" v-show="continue_cnt >= 5" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 5" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[4]">{{signList[4].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
            <li class="sign-days" :class="{active: continue_cnt >= 6}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 6" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.dlt')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.dlt')}}</div>
                <img class="icon" v-show="continue_cnt >= 6" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 6" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[5]">{{signList[5].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
            <li class="sign-days" :class="{active: continue_cnt >= 7}">
              <div class="t1" v-if="lang == 'ar'">
                <img class="icon" style="margin: 0 .2rem 0 0" v-show="continue_cnt >= 7" src="@/assets/new2/wancheng.png" alt="">
                <div>{{$t('langNew2.dqt')}}</div>
              </div>
              <div class="t1" v-else>
                <div>{{$t('langNew2.dqt')}}</div>
                <img class="icon" v-show="continue_cnt >= 7" src="@/assets/new2/wancheng.png" alt="">
              </div>
              <div class="img-box"><img v-if="continue_cnt >= 7" class="img" src="@/assets/new2/Goldcoin.png" alt=""><img v-else class="img" src="@/assets/new2/Gold-coin_transparent.png" alt=""></div>
              <div class="num" v-if="signList[6]">{{signList[6].bonus | toFixed4}}USDT</div>
              <div class="num" v-else>0.0000USDT</div>
            </li>
          </ul>
          <div class="btn-sign buttbg" @click="sign" v-if="isSign != 1">{{$t('langNew2.qd')}}</div>
          <div class="btn-sign buttbg" v-else>{{$t('langNew2.yqd')}}</div>
        </div>
        <div class="list-wrap">
          <ul class="list-head">
            <li class="item">{{$t('bbjy.sl')}}</li>
            <li class="item">{{$t('kxt.sj')}}</li>
          </ul>
          <ul class="list-box">
            <li class="list" v-for="(item,index) in signList" :key="index">
              <div>{{item.bonus| toFixed4}} USDT</div>
              <div>{{item.sign_time}}</div>
            </li>
            <!-- <li class="list">
              <div>0.02USDT</div>
              <div>2020-11-20</div>
            </li> -->
            <!-- 暂无数据 -->
            <div class="null-box" v-show="isNoData">
              <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
              <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
              <p class="text">{{$t('zwsj.title')}}</p>
            </div>
          </ul>
        </div>
        <div class="mask" v-show="isMask"></div>
        <div class="alert-sign-warp" v-show="isMask">
          <div class="alert-sign-box">
            <div class="t1">{{$t('langNew2.qdcg')}}</div>
            <div class="t2">{{total_bonus | toFixed4}}USDT</div>
          </div>
          <div class="close-box"><img class="close" src="@/assets/new2/dacha.png" @click="close" alt=""></div>
        </div>
        <!-- 返回顶部 -->
        <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
        <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
      </div>
    </div>
</template>

<script>
export default {
    name: 'sign',
    data () {
        return {
          theme: false,
          isMask: false,
          isSign: '',
          total_bonus: '',
          continue_cnt: 0,//连续签到
          signList: [],
          lang: 'en',
          isNoData: false,
          isGoTOP: false,
          curDataLength: 10,
          page: 1
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      this.getSignlog();
    },
    methods: {
       back(){
          this.$router.go(-1);
       },
       rule(){
         this.$router.push('/signRule')
       },
       close(){
         this.isMask = false
       },
       sign(){
        this.$ajax.post('/web/ethSign').then((res) => {
            let resData = res.data.data;
            if(res.data.code == 0){
              this.$toast.center(this.$t('langNew2.qdcg'));
              this.isMask = true;
              this.getSignlog();
            }else if(res.data.code == 1000){
            // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/login');
              },1000)
              return false
            }else{
              this.$toast.center(this.$t('langNew2.yqd'));
            }
        }).catch(function(err){
            console.log(err);
        })
      },
      getSignlog(){
        let params = {
          page: this.page
        }
        this.$ajax.get('/web/ethSignlog',params).then((res) => {
          if(res.data.code == 1000){
            // this.$toast.center(res.data.message);
            setTimeout(()=>{
              this.$router.push('/login');
            },1000)
            return false
          }
          let resData = res.data.data.list;
          this.isSign = res.data.data.today_sign;
          this.total_bonus = res.data.data.total_bonus;
          this.continue_cnt = res.data.data.continue_cnt;
          if(resData.length > 0){
            this.signList = this.signList.concat(resData);
            this.curDataLength = resData.length;
          }else{
            this.curDataLength = resData.length;
          }
          if(this.signList.length > 0){
            this.isNoData = false;
          }else{
            this.isNoData = true;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
        if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
            if(this.curDataLength > 0){
                this.page ++;
                this.getSignlog();
            }
        }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        padding: .5rem .44rem 0;
        color: #fff;
        background-image: linear-gradient(111deg,#77b4ff 0%,#1a7bff 100%);
        box-sizing: border-box;
        text-align: center;
        position: relative;
    }
    .head .back{
      width: .4rem;
      height: 0.6rem;
      position: absolute;
      left: 0.4rem;
    }
    .head .title{
      font-size: .56rem;
    }
    .head .rule{
      color: #fff;
      font-size: .48rem;
      position: absolute;
      right: 0.4rem;
    }
    .cotainer{
        position: absolute;
        left: .28rem;
        right: .28rem;
        top: 6.16rem;
        bottom: 0;
        z-index: 9;
        margin-top: -3.8rem;
        background: #f7f7f7;
        border-radius: 0.35rem .35rem 0 0;
        overflow-y: scroll;
    }
    .cotainer .sign-wrap{
      padding-bottom: .58rem;
      background: #fff;
      border-radius: .35rem;
    }
    .cotainer .sign-wrap .sign-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .42rem .96rem .42rem .24rem;
      color: #fff;
      font-size: .48rem;
      background-image: linear-gradient(90deg,
        #2883ff 0%,
        #0070d9 100%),
      linear-gradient(
        #157aed,
        #157aed);
      background-blend-mode: normal,
        normal;
      border-radius: 0.35rem .35rem 0 0;
    }
    .cotainer .sign-wrap .sign-box .money{
      font-size: .56rem;
    }
    .cotainer .sign-wrap .sign-box2{
      display: flex;
      justify-content: center;
      margin: .6rem 0;
    }
    .cotainer .sign-wrap .sign-box2 .sign-days{
      width: 2.5rem;
      margin-right: .3rem;
      border: 2px solid #b5d7fb;
      border-radius: 0.2rem;
      text-align: center;
    }
    .cotainer .sign-wrap .sign-box2 .sign-days:last-child{
      margin-right: 0;
    }
    .cotainer .sign-wrap .sign-box2 .sign-days.active{
      border: 2px solid #1f7eff;
    }
    .cotainer .sign-wrap .sign-box2 .t1{
      display: flex;
      justify-content: center;
      padding: .15rem 0;
      color: #fff;
      background: #b5d7fb;
      border-radius: 0.15rem .15rem 0 0;
    }
    .cotainer .sign-wrap .sign-box2 .sign-days.active .t1{
      padding: .1rem;
      background-image: linear-gradient(90deg,
        #74b2ff 0%,
        #4a98ff 50%,
        #1f7eff 100%),
      linear-gradient(
        #ffe2c2,
        #ffe2c2);
      background-blend-mode: normal,
        normal;
    }
    .cotainer .sign-wrap .sign-box2 .sign-days.active .t1 .icon{
      width: .4rem;
      height: .5rem;
      margin-left: .2rem;
    }
    .cotainer .sign-wrap .sign-box2 .img{
      width: .68rem;
      height: .68rem;
      margin: .16rem 0;
    }
    .cotainer .sign-wrap .sign-box2 .num{
      padding-bottom: .28rem;
      color: #b2b2b2;
      font-size: .36rem;
    }
    .cotainer .sign-wrap .sign-box2 .sign-days.active .num{
      color: #4458ed;
    }
    .cotainer .sign-wrap .btn-sign{
      width: 5.82rem;
      height: 1.06rem;
      margin: auto;
      color: #fff;
      font-size: .42rem;
      line-height: 1.06rem;
      background-color: #000;
      border-radius: 0.54rem;
      text-align: center;
    }
    .list-wrap{
      margin: 0.4rem 0.2rem;
      padding: .54rem .6rem .54rem .45rem;
      border-radius: .35rem;
      background: #fff;
      box-shadow: 0 0 5px 2px #00000020;
    }
    .list-wrap .list-head{
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-bottom: .54rem;
      color: #000;
      font-size: .42rem;
    }
    .list-wrap .list-box .list{
      display: flex;
      justify-content: space-between;
      color: #7c7c7c;
      font-size: .42rem;
      padding-bottom: .7rem;
    }
    .alert-sign-warp{
      position: absolute;
      top: 50%;
      left: 1.48rem;
      right: 1.48rem;
      z-index: 1000;
      transform: translateY(-50%);
      text-align: center;
    }
    .alert-sign-warp .alert-sign-box{
      width: 7.7rem;
      height: 5.18rem;
      color: #fff;
      background: url('../assets/new2/chenggong.png') no-repeat center center;
      background-size: cover;
    }
    .alert-sign-warp .alert-sign-box .t1{
      padding: 2.8rem 0 .56rem;
      font-size: .42rem;
    }
    .alert-sign-warp .alert-sign-box .t2{
      font-size: .56rem;
    }
    .alert-sign-warp .close{
      width: 1.22rem;
      margin-top: .58rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/sign.vue